import { useState, useEffect } from "react"
import {
    SubmitBtn,
    ActionSection,
    SideCancelBtn,
} from "../Styles/InputStyles"
import { MdClose } from "react-icons/md"
import tw from "tailwind-styled-components"
import "react-dropdown/style.css"
import { GoSearch } from "react-icons/go"
import { toast } from "react-toastify"
import SelectStaffModal from "./SelectStaffModal"

const FilterModal = ({
    staffs,
    onApplyFilter,
    handleClose,
    selectedStaff,
    setSelectedStaff
}) => {
    const [height, setHeight] = useState(window.innerHeight);
    const [isStaffModalOpen, setIsStaffModalOpen] = useState(false);

    const handleStaffSave = (staff) => {
        setSelectedStaff(staff)
        setIsStaffModalOpen(false)
    }

    const handleApplyFilter = () => {
        if (selectedStaff)
            onApplyFilter(selectedStaff.value, selectedStaff.label);
        else
            toast.error("Please select at least one filter before applying.");
    };

    useEffect(() => {
        const handleResize = () => {
            setHeight(window.innerHeight)
        }
        window.addEventListener("resize", handleResize)
        handleResize()
        return () => {
            window.removeEventListener("resize", handleResize)
        }
    }, [])
    return (
        <Container style={{ height: `${height}px`, overflow: "auto", WebkitOverflowScrolling: "touch" }}>
            <Header>
                <h1 className="text-lg font-medium text-white">Filters</h1>
                <button onClick={handleClose}>
                    <MdClose color="white" size={24} />
                </button>
            </Header>
            <div className="p-4 relative">
                <FilterTitle>{"Search By Staff"}</FilterTitle>

                <div className="relative mt-2">
                    <input
                        type="text"
                        placeholder="Search staffs..."
                        value={selectedStaff?.label || ""}
                        readOnly
                        onClick={() => setIsStaffModalOpen(true)}
                        className="w-full px-8 h-12 py-2 border border-gray-200 rounded-md focus:outline-none focus:border-primary-color text-gray-800 placeholder-gray-300 cursor-pointer"
                    />
                    <div className="absolute left-3 top-1/2 transform -translate-y-1/2">
                        <GoSearch className="w-4 h-4 text-gray-400" />
                    </div>
                </div>
            </div>

            <div className="custom-scrollbar flex h-full flex-col justify-between px-4">
                {selectedStaff && (
                    <div className="flex flex-wrap gap-2 mt-3">
                        <div className="flex items-center bg-primary-color/10 text-primary-color 
                      px-3 py-1 rounded-full text-sm">
                            {selectedStaff.label}

                            <button
                                onClick={() => setSelectedStaff(null)}
                                className="ml-2 text-primary-color hover:text-red-500"
                            >
                                <MdClose size={16} />
                            </button>
                        </div>
                    </div>
                )}
                <ActionSection>
                    <SideCancelBtn type="button" onClick={handleClose}>
                        {selectedStaff ? "Clear" : "Cancel"}
                    </SideCancelBtn>
                    <SubmitBtn type="submit" onClick={handleApplyFilter}>
                        Apply Filter
                    </SubmitBtn>
                </ActionSection>
            </div>
            <SelectStaffModal
                isOpen={isStaffModalOpen}
                onClose={() => setIsStaffModalOpen(false)}
                title="Select Staff"
                options={staffs || []}
                selectedValue={selectedStaff?.value}
                onSelect={handleStaffSave}
                searchPlaceholder="Search staff..."
            />
        </Container>
    )
}

const Container = tw.div`bg-white w-full h-full flex flex-col relative`
const Header = tw.div`flex items-center justify-between bg-primary-color py-4 px-4`
const FilterTitle = tw.h3`text-md font-medium text-gray-800 mb-2`;

export default FilterModal